import React from "react";
import "./SideNavigationBarContact.css";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";

function Contact() {
  return (
    <div>
      <div className="sidenavigationbarcontact">
        <CallOutlinedIcon />
        <h3>Contact Us</h3>
      </div>
    </div>
  );
}

export default Contact;
